// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import TabNavigation from '../../../shared/components/tab-navigation';
import {getNavigationTabs} from '../../shared/services/pip-navigation-helper';
import {hasAccess} from '../../../shared/services/security';

const PipSearchHeader = (props, context) => {

    const countObject = {
        laborAdditive: props.laborAdditivePipProductsCount,
        openPips: props.openPipProductsCount,
        pipSearch: props.searchResultsCount
    };

    return (
        <header className='pip-search-header'>
            <TabNavigation
                tabs={getNavigationTabs(countObject, true, hasAccess(context.security, 'PIP', 'PIP_LABOR_ADD_SUMM'))}
            />
        </header>
    );

};

PipSearchHeader.displayName = 'PipSearchHeader';
PipSearchHeader.propTypes = {
    laborAdditivePipProductsCount: PropTypes.number.isRequired,
    openPipProductsCount: PropTypes.number.isRequired,
    searchResultsCount: PropTypes.number.isRequired
};
PipSearchHeader.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default PipSearchHeader;



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/pip-search-header.js